import { Autocomplete, TextField } from "@mui/material"
import { useState, useEffect } from "react"
import { API } from "../../services/API/API";

export default function Course({value, onChange, required, disabled, sx}){

    const [courses, setCourses] = useState([]);
    const [titleValue, setTitleValue] = useState(value?.title || '')

    useEffect(() => {

        API.getCourses()
            .then(r => setCourses(Array.isArray(r.data) ? r.data : []))
            .catch(e => console.log(e))

    }, [])

    const handleChange = title => {
        setTitleValue(title)
        let course = courses.find(c => c.title === title);
        return onChange(course)
    }

    const courseTitles = () => {
        let titles = [''];

        courses.forEach(c => {
            if(titles.indexOf(c.title) < 0) titles.push(c.title);
        })

        return titles;
    }

    return <Autocomplete
        options={courseTitles()}
        renderInput={params => <TextField 
            {...params}
            label='Formation'
            size='small'
            required={required ? true : false}
        />}
        value={titleValue}
        onChange={(e, v) => handleChange(v)}
        disabled={disabled ? true : false}
        sx={sx || {}}
    />
}